import {useStore} from "vuex";
import {computed} from "vue";

export function useRoles () {
    const store = useStore();

    const roles = computed(() => store.getters.getRolesList);
    const rolesApp = computed(() => store.getters.getAppRolesList);

    const loadRoles = async () => {
        await store.dispatch('fetchRoles');
    };

    const loadAppRoles = async () => {
        await store.dispatch('fetchAppRoles');
    };

    return {roles, rolesApp, loadRoles, loadAppRoles};
}